var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 6.66667V16.25C16.6667 17.4006 15.7339 18.3333 14.5833 18.3333H5.41667C4.26607 18.3333 3.33333 17.4006 3.33333 16.25V6.66667H16.6667ZM11.6667 9.58333H8.33333C7.98816 9.58333 7.70833 9.86316 7.70833 10.2083C7.70833 10.5535 7.98816 10.8333 8.33333 10.8333H11.6667C12.0118 10.8333 12.2917 10.5535 12.2917 10.2083C12.2917 9.86316 12.0118 9.58333 11.6667 9.58333ZM16.6667 2.5C17.1269 2.5 17.5 2.8731 17.5 3.33333V5C17.5 5.46024 17.1269 5.83333 16.6667 5.83333H3.33333C2.8731 5.83333 2.5 5.46024 2.5 5V3.33333C2.5 2.8731 2.8731 2.5 3.33333 2.5H16.6667Z",
    fill: "#1D72E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveFilled);
export default __webpack_public_path__ + "static/media/archive_filled.c40fdae2d29305d02e6069919321c91c.svg";
export { ForwardRef as ReactComponent };